import {
  TEXTO_INSCRICAO_RECEBIDA,
  situacaoNeutra,
  type SituacaoInscrito,
} from '@/lib/situacaoInscrito';

interface Props {
  situacao?: SituacaoInscrito | null;
  /** Antes da resposta da função, mostra o selo neutro. */
  carregando?: boolean;
  /** Mostra também a frase explicativa embaixo do selo. */
  comTexto?: boolean;
  className?: string;
}

const CONFIG: Record<
  string,
  { label: string; classes: string; icone: string }
> = {
  confirmada: {
    label: 'Confirmada',
    classes: 'bg-accent-100 text-accent-900',
    icone: 'ri-check-line',
  },
  isenta: {
    label: 'Isenta',
    classes: 'bg-accent-100 text-accent-900',
    icone: 'ri-gift-line',
  },
  pendente: {
    label: 'Aguardando pagamento',
    classes: 'bg-warning-100 text-warning-800',
    icone: 'ri-time-line',
  },
  cancelada: {
    label: 'Cancelada',
    classes: 'bg-danger-100 text-danger-700',
    icone: 'ri-close-circle-line',
  },
};

/**
 * Selo de situação do participante.
 * Sigilo (ou antes da resposta) usa SEMPRE o neutro "Inscrição recebida" —
 * nunca verde de confirmada nem âmbar de suplente.
 */
export default function SeloSituacaoInscrito({
  situacao,
  carregando = false,
  comTexto = false,
  className = '',
}: Props) {
  const base = situacao ?? situacaoNeutra();
  const neutro = carregando || base.sigilo || base.situacao === 'recebida';

  if (neutro) {
    return (
      <div className={className}>
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-200/80 px-2.5 py-0.5 text-xs font-semibold text-foreground-700">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-mail-line" aria-hidden />
          </span>
          Inscrição recebida
        </span>
        {comTexto && (
          <p className="mt-2 text-[14px] leading-relaxed text-foreground-600">
            {base.texto || TEXTO_INSCRICAO_RECEBIDA}
          </p>
        )}
      </div>
    );
  }

  if (base.situacao === 'lista_espera') {
    return (
      <div className={className}>
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-semibold text-secondary-800">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-stack-line" aria-hidden />
          </span>
          Suplente
        </span>
        {comTexto && (
          <p className="mt-2 text-[14px] leading-relaxed text-foreground-600">
            Você é suplente — avisaremos se abrir uma vaga.
          </p>
        )}
      </div>
    );
  }

  const cfg = CONFIG[base.situacao] ?? CONFIG.pendente;
  return (
    <div className={className}>
      <span
        className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold ${cfg.classes}`}
      >
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className={cfg.icone} aria-hidden />
        </span>
        {cfg.label}
      </span>
    </div>
  );
}